// Module
var code = "<div class=\"grid-stack\"></div> ";
// Exports
export default code;